/**
 * Start a Stripe Checkout for extra quotes and leave for it.
 *
 * The billing page keeps its own `startCheckout` — it carries the courtesy
 * code parked by /promo and the page's own status banner. This is the bare
 * version for the places that only ever buy extras: the out-of-quotes card on
 * the quote form and on Dany's quote card. Throws on failure so the caller can
 * say so in its own words.
 */
import api from "@/lib/api";

/**
 * The quantities offered at a tap: the extra quote card's presets and the
 * out-of-quotes card's three buttons are the same list, so they cannot drift.
 * Each surface still drops any above `extra_credit_max_per_purchase`, the cap
 * the checkout clamps to.
 */
export const EXTRA_QUOTE_PRESETS = [1, 5, 10];

export async function startExtraQuoteCheckout(quantity = 1) {
  const { data } = await api.post("/billing/checkout", {
    plan: "credits",
    credits_quantity: quantity,
    origin_url: window.location.origin,
  });
  if (!data?.url) throw new Error("checkout_without_url");
  window.location.href = data.url;
  return data;
}

/** "$3.00" — two decimals, always; the price is a number from the server. */
export function usd(amount) {
  const n = Number(amount);
  return Number.isFinite(n) ? `$${n.toFixed(2)}` : "";
}
